import styled from 'styled-components';

export const PageContainerWrapper = styled.div`
  min-height: 100%;
  background: #f8f9fc;
  color: #1f2937;
  display: flex;
  flex-direction: column;
`;

export const PageContainerMain = styled.main`
  margin: 0 auto;
  padding: 32px 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  overflow: auto;
`;
